import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from 'src/app/shared/utils/environment.util';
import { mapItemsToAppConfig } from 'src/app-config.bootstrap';

interface ConfigEnvironmentItem {
  id: string;
  key: string;
  value: string;
  description: string;
  environment: string;
}

@Injectable({
  providedIn: 'root',
})
export class PrivateConfigService {
  private readonly http = inject(HttpClient);
  private readonly envService = inject(EnvironmentService);

  private get configUrl(): string {
    const platform = Capacitor.getPlatform();
    const envName = environment.environmentName;
    return `${environment.endpointBasePaths.cmsApiUrl}public/catalog/config-environment/private?environment=${envName}&platform=${platform}`;
  }

  /**
   * Fetches private environment config from CMS API (requires Bearer token)
   * and merges values into the environment object.
   * Called once after Keycloak authentication succeeds.
   */
  loadAndApply(): Observable<void> {
    return this.http.get<ConfigEnvironmentItem[]>(this.configUrl).pipe(
      tap((items) => {
        const config = mapItemsToAppConfig(items);
        this.envService.applyConfig(config);
      }),
      tap({ error: (err) => console.error('[PrivateConfigService] Failed to load private config:', err) })
    ) as unknown as Observable<void>;
  }
}
